import { Pencil } from "lucide-react";

export const MasterUpdateTag = ({ day, testid }) => {
  if (!day?.master_update) return null;
  return (
    <div className="mb-1.5">
      <span
        className="inline-flex items-center gap-1 rounded-full bg-indigo-600 text-white px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider"
        title={day.master_update_by_name ? `Updated by ${day.master_update_by_name}` : "Updated from Payroll"}
        data-testid={testid}
      >
        <Pencil className="w-2.5 h-2.5" /> Master Update
      </span>
    </div>
  );
};
